module.exports = __webpack_public_path__ + "media/images/video/stretchlab-app-promo-63a7c63004f0846b29ab53c87e7d6185.png";